import { isValid, parseISO } from 'date-fns';

const DISPLAY_PARTS = {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
} as const;

const SAST_OFFSET = '+02:00';

const sastFormatter = new Intl.DateTimeFormat('en-ZA', {
  ...DISPLAY_PARTS,
  timeZone: 'Africa/Johannesburg',
});

export function formatUtcAsSast(utcTimestamp: string): string {
  const parsed = parseISO(utcTimestamp);
  if (!isValid(parsed)) return '';

  return sastFormatter.format(parsed);
}

// send_at arrives as "2026-08-21 08:00:00" — already South African, with no zone
// on the end, because that is the only shape the gateway accepts. Adding the
// offset makes it a real instant without moving the clock time.
export function formatSastAsWritten(sastTimestamp: string): string {
  const parsed = parseISO(`${sastTimestamp.replace(' ', 'T')}${SAST_OFFSET}`);
  if (!isValid(parsed)) return '';

  return sastFormatter.format(parsed);
}
